export default (imageData) => {
  if (imageData != null) {
    let output = {
      imageSource: imageData.node.sourceUrl,
      imageChildSharp: imageData.node.localFile.childImageSharp,
      altText: imageData.node.altText,
    };
    return output;
  }

  return imageData;
};
